// Import required libraries using package manager
import React from "react";
import { render } from "react-dom";
import Nav from "./Nav.js";

class Services extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="services-page">
        <Nav content={this.props.content} theme={this.props.theme} />

        <div className="tg-bar-main" />

        <div className="services-title">
          <h1 className="caption-title ">Services</h1>

          <h3 className="caption-description ">Blah blah blah</h3>
        </div>

        <div className="services-code">
          <code id="services-code-block" />
        </div>
      </div>
    );
  }
}

export default Services;
